"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkbox = void 0;
const colors_1 = require("./colors");
exports.checkbox = {
    backgroundColor: colors_1.colors.white,
    tick: colors_1.colors.neutral[900],
    borderColor: colors_1.colors.neutral[400],
    labelColor: colors_1.colors.dark[400],
    checked: {
        backgroundColor: colors_1.colors.white,
        borderColor: colors_1.colors.neutral[900],
        labelColor: colors_1.colors.dark[400],
    },
    disabled: {
        backgroundColor: colors_1.colors.neutral[200],
        borderColor: colors_1.colors.neutral[200],
        labelColor: colors_1.colors.light[600],
    },
};
